<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.editTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="processing-time-translation-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              {{ $t('settings.processingTime.processingTimeName') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('settings.transaltion.editTranslation') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'processing-time-translation-edit-popup',
  props: {
    processingTimeID: {
      default: 0,
      type: Number
    },
    translationData: {
      default: () => ({}),
      type: Object
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages.filter(language => language.id > 1).map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.translationData.language_id,
      translationID: this.translationData.id,
      name: this.translationData.name
    };
  },
  methods: {
    handleClose (translationID) {
      this.$bus.$emit('processing-time-translation-edit-popup-close', translationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['processing-time-translation-edit-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/processing-time/translations/update/' + this.translationID,
        formData: {
          processing_time_id: this.processingTimeID,
          language_id: this.language,
          name: this.name
        },
        successTitle: this.$t('settings.transaltion.translationEditSuccessTitle'),
        successText: this.$t('settings.transaltion.translationEditSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.translationEditErrorText'),
        successAction: res => {
          this.$bus.$emit('processing-time-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
